var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col  items-center"},[_c('div',{staticClass:"m-b-16"},[_vm._v("东方思锐-有备平台")]),_c('div',{ref:"qrcode",attrs:{"id":"qrcode"}}),_c('div',{staticClass:"m-t-16"},[_vm._v("请使用思锐APP扫描二维码登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }